<template>
    <el-main style="min-height: 100vh;">
        <router-view @containerChange="containerChangeEvent"/>
    </el-main>
</template>

<script>
export default {
    name: 'Container',
    data () {
        return {}
    },
    methods: {
        containerChangeEvent (status) {
            this.$emit('containerChange', status)
        }
    }
}
</script>

<style scoped>
    .el-main {
        background-color: #f6f9f8;
        color: #333;
        text-align: center;
        /*line-height: 160px;*/
        padding: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/layouts/Container.vue